import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import formatter from '../../../common/helpers/formatter';
import groupForm from '../../../documentation/fhbfForm/counselingCenterForm/forms/groupForm';
import type { DocumentationStatistic } from '../../../common/types/statistics/fbStatistics';
import type { AppDispatch } from '../../../store';
import settingsSelectors from '../../../settings/settingsSelector';
import { loadGroups } from '../../../settings/settingsReducer';

type Props = {
  statistics: DocumentationStatistic;
};

function GroupStatistics({ statistics }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const groups = useSelector(settingsSelectors.getGroups);
  const { group } = statistics;

  const groupOptions = formatter.getFieldSelectOptions('group', groupForm(groups).fields);

  React.useEffect(() => {
    dispatch(loadGroups());
  }, []);

  return (
    <Stack direction='column'>
      <Typography component='h3' variant='h6' fontWeight='bold'>
        Gruppen
      </Typography>
      {Object.keys(group).map((key) => (
        <Stack key={key} spacing={1}>
          <Typography fontWeight='bold'>{formatter.getOptionLabel(groupOptions, key)}</Typography>
          <Typography>Anzahl der Termine: {group[key].numberOfAppointments}</Typography>
          <Typography>Anzahl der Stunden: {group[key].numberOfHours}</Typography>
          <Typography>Anzahl der Teilnehmenden: {group[key].numberOfParticipants}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}

export default GroupStatistics;
